/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/mauritius-project.jpg";

function AboutUs() {
  return (
    <>
      <DefaultNavbar brand="Alpha Group" routes={routes} transparent light />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Our Vision & Legacy
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Alpha Group, established in 1996, is a global leader in high-end real estate,
              construction, and infrastructure. Our commitment to excellence has shaped landscapes
              across international borders.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox py={12}>
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={10}
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h2" fontWeight="bold">
                A Journey of Excellence Since 1996
              </MKTypography>
              <MKTypography variant="body1" color="text" mt={4}>
                Stellar Group, established in 1996, has diversified business interests in{" "}
                <b>Real Estate and Construction & Hospitality</b>. With a strong commitment to
                quality and driven by passion, Alpha Group has achieved remarkable success over the
                years.
              </MKTypography>
              <MKTypography variant="body1" color="text" mt={2}>
                To date, we have successfully developed and constructed over{" "}
                <b>10 million sq. ft.</b> of residential, commercial, and industrial projects.
                Currently, the company has major infrastructure projects underway in{" "}
                <b>Azerbaijan</b> and <b>Mauritius</b>, encompassing a total area of about{" "}
                <b>3 million sq. ft.</b>
              </MKTypography>
              <MKTypography variant="body1" color="text" mt={2}>
                Our expansion into the Strategic Markets of Baku and Port Louis marks a new chapter
                in our global mission to deliver architectural masterpieces and sustainable
                infrastructure solutions.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
